/* eslint-disable guard-for-in */
import { concat, groupBy, isNil, orderBy } from 'lodash-es';

import { FieldStatus, FieldStatusInput } from 'generated/graphql';

import { CONTACT_SOURCES, SOCIAL_NETWORK_SORT_ORDER } from 'core/shared-constants';

export interface IStatusable {
  status: FieldStatus | FieldStatusInput;
  source?: string;
  updatedAt: any; // Should be date number
}

/**
 * Business logic that can be used to get the best
 * Address, Phone or Email from a collection of
 * addresses, phones and emails on Person object.
 *
 * @param input string input
 */
export function sortByBest<T extends IStatusable>(items: T[], showBads = false): T[] {
  if (isNil(items)) {
    items = [];
  }

  const sortBySourceThenDate = (inputs: T[]) => orderBy(inputs, [(i) =>
    CONTACT_SOURCES[i.source]?.sortOrder, 'updatedAt'], ['asc', 'desc']);

  const verifieds = sortBySourceThenDate(items.filter(t => t.status === 'verified'));
  const userAddeds = sortBySourceThenDate(items.filter(t => t.status === 'user_added'));
  const doNotContacts = sortBySourceThenDate(items.filter(t => t.status === 'do_not_contact'));
  const bads = sortBySourceThenDate(items.filter(t => t.status === 'bad'));

  const sorted: T[] = concat(
    verifieds, userAddeds, doNotContacts,
    (showBads ? bads : [])
  );

  return sorted;
}

/**
 * Sorting the social profiles on the basis of label in the
 * ascending order, status and then the updated profile date
 */
export function sortByLabel(items: any[], showBads = false): any[] {
  if (isNil(items)) {
    items = [];
  }

  const sortProfiles = (inputs: any[]) => orderBy(inputs,
    [(i) => SOCIAL_NETWORK_SORT_ORDER[i.socialNetwork.id] , 'updatedAt'],
    ['asc', 'desc']);

  const bads = showBads ? sortProfiles(items.filter(t => t.status === 'bad')) : [];
  const verified = sortProfiles(items.filter(t => t.status === 'verified'));
  const user_added = sortProfiles(items.filter(t => t.status === 'user_added'));

  return [ ...verified, ...user_added, ...bads];
}


/**
 * Business logic that can be used to get the best
 * Address, Phone or Email from a collection of
 * addresses, phones and emails on Person object.
 *
 * @param input string input
 */
export function interactBest<T extends IStatusable>(items: T[]): T {
  return sortByBest(items)[0];
}
